import request from '@/utils/request'


// 查询生产工艺列表
export function listGoodsProcess(query) {
  return request({
    url: '/biz/admin/goods/goods/process/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询生产工艺分页
export function pageGoodsProcess(query) {
  return request({
    url: '/biz/admin/goods/goods/process/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询生产工艺详细
export function getGoodsProcess(data) {
  return request({
    url: '/biz/admin/goods/goods/process/detail',
    method: 'get',
    params: data
  })
}

// 新增生产工艺
export function addGoodsProcess(data) {
  return request({
    url: '/biz/admin/goods/goods/process/add',
    method: 'post',
    data: data
  })
}

// 修改生产工艺
export function updateGoodsProcess(data) {
  return request({
    url: '/biz/admin/goods/goods/process/edit',
    method: 'post',
    data: data
  })
}

// 删除生产工艺
export function delGoodsProcess(data) {
  return request({
    url: '/biz/admin/goods/goods/process/delete',
    method: 'post',
    data: data
  })
}
